import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { suggestions } from "../actions/suggestions";
import Swal from "sweetalert2";
import { Form, Input, Select, Button, Typography } from "antd";
import Header from "./layout/Header";

const { TextArea } = Input;
const { Option } = Select;
const { Title, Paragraph } = Typography;

function RequestAndSuggestions(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm(); // Ant Design form kontrolü
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  useEffect(() => {
    if (props.suggestions.done) {
      Swal.fire({
        title: "Başarılı!",
        text: "İstek ve önerileriniz başarıyla gönderildi.",
        icon: "success",
        confirmButtonText: "Tamam"
      }).then(() => {
        navigate("/select-facility"); // Başarılı olunca yönlendirme
        window.location.reload()
      });
      return;
    }

    if (props.suggestions.error !== false) {
      Swal.fire({
        title: "Hata!",
        text: "İstek ve önerileriniz gönderilirken bir hata oluştu.",
        icon: "error",
        confirmButtonText: "Tamam"
      });
      return;
    }
  }, [props.suggestions]);

  const handleFormChange = () => {
    // Form alanlarını kontrol et
    const values = form.getFieldsValue();
    const isFormValid = values.title && values.description;
    setIsSubmitDisabled(!isFormValid);
  };

  const handleSubmit = () => {
    const values = form.getFieldsValue();
    dispatch(suggestions(values.description, 1)); // Açıklamayı gönder
  };

  return (
    <div>
      <Header />

      <div className="pt-10 md:ml-64 ps-5">
        <ol
          className="flex items-center whitespace-nowrap min-w-0"
          aria-label="Breadcrumb"
        >
          <li
            className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200"
            aria-current="page"
          >
            İstek ve Öneriler
          </li>
        </ol>
      </div>
      <hr className="divide-y mt-2" />
      <div className="md:ml-64 ps-5">
        <Title level={3}>İstek ve Önerileriniz</Title>
        <Paragraph>
          Bu Form; sizlere daha iyi hizmet verebilmek amacıyla uygulamayla
          ilgili geri bildirimleriniz için hazırlanmıştır. İlginiz ve katkınız
          için teşekkür ederiz.
        </Paragraph>
      </div>
      <div className="pt-10 md:ml-64 ps-5 pe-4">
        <Form
          form={form}
          layout="vertical"
          onValuesChange={handleFormChange} // Form değişikliklerini dinle
        >
          <Form.Item
            label="Başlık"
            name="title"
            rules={[{ required: true, message: "Lütfen bir başlık seçiniz!" }]}
          >
            <Select placeholder="Lütfen başlık seçiniz">
              <Option value="İstek">İstek</Option>
              <Option value="Şikayet">Şikayet</Option>
              <Option value="Teşekkür">Teşekkür</Option>
              <Option value="Proje">Proje</Option>
              <Option value="Bilgi">Bilgi</Option>
              <Option value="İhbar">İhbar</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Açıklama"
            name="description"
            rules={[
              { required: true, message: "Lütfen bir açıklama giriniz!" }
            ]}
          >
            <TextArea rows={5} placeholder="İstek ve önerileriniz" />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              onClick={handleSubmit}
              disabled={isSubmitDisabled} // Form alanları dolu değilse buton devre dışı
              block
            >
              Gönder
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return state;
};
const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RequestAndSuggestions);
